;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      latitude: "0.0",
      longitude: "0.0",
      isLoading: false,
      error: null
    };
  },

  methods: {
    getLocation: async function getLocation() {
      this.isLoading = true;
      this.error = null;

      try {
        var permission = await navigator.permissions.query({
          name: "geolocation"
        });

        if (permission.state === "granted") {
          var position = await new _promise2.default(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 0
            });
          });
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        }
        this.$emit("location", {
          latitude: this.latitude,
          longitude: this.longitude
        });
      } catch (error) {
        this.error = error.message;
        this.latitude = "0.0";
        this.longitude = "0.0";
        this.$emit("location", {
          latitude: this.latitude,
          longitude: this.longitude
        });
      }
    }
  },
  mounted: function mounted() {
    this.getLocation();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"latitude"},domProps:{"value":_vm.latitude}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"longitude"},domProps:{"value":_vm.longitude}})])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-efb2e7c4", __vue__options__)
  } else {
    hotAPI.reload("data-v-efb2e7c4", __vue__options__)
  }
})()}